import { BaseOrderJson, OfferJson } from "../OrderForm";
import { OfferCode } from "./OfferUtils";

export interface SmeRepresentative {
    name: string;
}

export interface SmeOrderJson extends BaseOrderJson {
    startdate: string;

    representatives: SmeRepresentative[];
    terms_person: boolean;

    savings: any;

    recooffer?: OfferJson;

    ocr_price: number;

    code: OfferCode;

    si_osds: any[];
    si_vendors: any[];
}

export default class SmeUtils {
    public static getDueDays(offer: OfferJson): number {
        const map = {
            12: 14,
            24: 14,
            36: 21,
            60: 25,
            120: 30,
        };

        return offer.price_warranty ? map[offer.price_warranty] : null;
    }
}
